import { useTranslation } from "react-i18next";

function Cookie() {
  const { t } = useTranslation();

  return (
    <section id="cookie" className="cookies-section">
      <div>
        <div className="base-text-container">
          <h2 className="base-title">{t("cookies.title")}</h2>

          <p className="base-subtitle">{t("cookies.subtitle1")}</p>
          <p className="base-paragraph whitespace-pre-line">
            {t("cookies.text1")}
          </p>

          <p className="base-subtitle">{t("cookies.subtitle2")}</p>
          <p className="base-paragraph whitespace-pre-line">
            {t("cookies.text2")}
          </p>

          <p className="base-subtitle">{t("cookies.subtitle3")}</p>
          <p className="base-paragraph whitespace-pre-line">
            {t("cookies.text3")}
          </p>

          <p className="base-subtitle">{t("cookies.subtitle4")}</p>
          <p className="base-paragraph whitespace-pre-line">
            {t("cookies.text4")}
          </p>

          <p className="base-subtitle">{t("cookies.subtitle5")}</p>
          <p className="base-paragraph whitespace-pre-line">
            {t("cookies.text5")}
          </p>

          <p className="base-subtitle">{t("cookies.subtitle6")}</p>
          <p className="base-paragraph whitespace-pre-line">
            {t("cookies.text6")}
          </p>

          <p className="base-subtitle">{t("cookies.subtitle7")}</p>
          <p className="base-paragraph whitespace-pre-line">
            {t("cookies.text7")}
          </p>
        </div>
      </div>
    </section>
  );
}

export default Cookie;
